import React, {useCallback} from "react";
import {FormProvider, UseFormReturn} from "react-hook-form";
import {trackPromise} from "react-promise-tracker";
import {Subject} from "rxjs";
import _ from "lodash";
import {FatOutlineButton} from "common/component/FatOutlineButton";
import {LoadingSpinner} from "common";
import {MissingDocumentationInput} from "../../domain";
import MissingDocumentsInput from "./MissingDocumentsInput";
import { OtherDocumentationsInput } from "./OtherDocumentsInput";

type Props = {
    visible$: Subject<boolean>;
    methods: UseFormReturn<MissingDocumentationInput>;
    onFinished: (formValues: MissingDocumentationInput | null) => Promise<void>;
    onCancel: () => Promise<void>;
    externalLoading: boolean;
};

export function MissingDocumentationForm({visible$, onFinished, methods, onCancel, externalLoading}: Props) {

    const submitWithTracking = useCallback((formValues: MissingDocumentationInput | null) => trackPromise(onFinished(formValues)), [onFinished]);

    const submit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        await methods.handleSubmit(async (data: MissingDocumentationInput) => {
            await submitWithTracking(_.pick(data, [
                'missingDocumentations',
                'otherDocumentations',
            ]));
            methods.reset();
            visible$.next(false);
        })(e);
    }, [methods, visible$, submitWithTracking]);

    return (
        <FormProvider {...methods}>
            <form autoComplete="off" onSubmit={submit}>
                {!externalLoading && (<>
                    <div className={"p-2"}/>
                    <MissingDocumentsInput sending={false}/>
                    <OtherDocumentationsInput sending={false}/>

                    <div className="w-full flex border-t dark:border-gray-600 p-4 justify-end">
                        <div className="flex w-1/4">
                            <FatOutlineButton color={'red'}
                                              text={"Cancel"}
                                              onClick={onCancel}/>
                            <span style={{width: 10}}/>
                            <FatOutlineButton type="submit" text={"Submit"} color={"green"}/>
                        </div>
                    </div>
                </>)}

                {externalLoading &&
                    <div className="p-24">
                        <LoadingSpinner text="Processing"/>
                    </div>
                }
            </form>
        </FormProvider>
    );
}
